(function () {
  function removeVariantParam() {
    if (window.location.search.includes('variant=')) {
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }

  removeVariantParam();

  const originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(this, arguments);
    removeVariantParam();
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    removeVariantParam();
  };

  window.addEventListener('popstate', removeVariantParam);
})();
